/* Odara store locator — Leaflet + filtros + sincronía tarjeta<->pin. Vanilla, sin deps salvo Leaflet. */
(function () {
  'use strict';

  function deaccent(s) {
    return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function whenLeafletReady(cb, tries) {
    tries = tries == null ? 100 : tries;
    if (typeof window.L !== 'undefined') return cb(window.L);
    if (tries <= 0) return; // Leaflet no cargó; las tarjetas siguen visibles (SSR)
    setTimeout(function () { whenLeafletReady(cb, tries - 1); }, 50);
  }

  function pinIcon(L, accent) {
    var svg =
      '<span class="odara-pin"><svg width="28" height="36" viewBox="0 0 28 36" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M14 0C6.3 0 0 6.3 0 14c0 9.5 14 22 14 22s14-12.5 14-22C28 6.3 21.7 0 14 0z" fill="' + accent + '"/>' +
      '<circle cx="14" cy="14" r="5" fill="#fff"/></svg></span>';
    return L.divIcon({ html: svg, className: '', iconSize: [28, 36], iconAnchor: [14, 36], popupAnchor: [0, -32] });
  }

  function initLocator(root) {
    var accent = getComputedStyle(root).getPropertyValue('--ol-accent').trim() || '#1b3a5b';
    var mapEl = root.querySelector('[data-ol-map]');
    var listEl = root.querySelector('[data-ol-list]');
    var emptyEl = root.querySelector('[data-ol-empty]');
    var searchEl = root.querySelector('[data-ol-search]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-ol-chip]'));
    var viewBtns = Array.prototype.slice.call(root.querySelectorAll('[data-ol-view]'));
    var bodyEl = root.querySelector('[data-ol-view-state]');

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ol-card]'));
    var stores = cards.map(function (card) {
      var lat = parseFloat(card.getAttribute('data-lat'));
      var lng = parseFloat(card.getAttribute('data-lng'));
      return {
        card: card,
        region: card.getAttribute('data-region') || '',
        search: deaccent(card.getAttribute('data-search')),
        lat: lat, lng: lng,
        hasGeo: isFinite(lat) && isFinite(lng),
        marker: null,
      };
    });

    var activeRegion = '';
    var query = '';

    function matches(s) {
      var byRegion = !activeRegion || s.region === activeRegion;
      var byQuery = !query || s.search.indexOf(query) !== -1;
      return byRegion && byQuery;
    }

    // ---- Map ----
    whenLeafletReady(function (L) {
      var map = L.map(mapEl, { scrollWheelZoom: false, zoomControl: true });
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      }).addTo(map);
      var icon = pinIcon(L, accent);

      stores.forEach(function (s) {
        if (!s.hasGeo) return;
        s.marker = L.marker([s.lat, s.lng], { icon: icon })
          .addTo(map)
          .bindPopup('<strong>' + (s.card.getAttribute('data-name') || '') + '</strong>');
        s.marker.on('click', function () { highlight(s, false); });
      });

      function fitVisible() {
        var pts = stores.filter(function (s) { return s.marker && matches(s); })
          .map(function (s) { return [s.lat, s.lng]; });
        if (pts.length) map.fitBounds(pts, { padding: [40, 40], maxZoom: 14 });
      }
      root._olFitVisible = fitVisible;
      root._olMap = map;
      fitVisible();
      // Leaflet necesita recalcular tamaño si el contenedor estaba oculto
      setTimeout(function () { map.invalidateSize(); }, 200);
    });

    function highlight(store, fromCard) {
      stores.forEach(function (s) { s.card.classList.remove('is-active'); });
      store.card.classList.add('is-active');
      if (fromCard && store.marker && root._olMap) {
        root._olMap.setView([store.lat, store.lng], Math.max(root._olMap.getZoom(), 13));
        store.marker.openPopup();
      } else if (!fromCard) {
        store.card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function applyFilters() {
      var shown = 0;
      stores.forEach(function (s) {
        var ok = matches(s);
        s.card.hidden = !ok;
        if (s.marker) { ok ? s.marker.addTo(root._olMap) : root._olMap.removeLayer(s.marker); }
        if (ok) shown++;
      });
      if (emptyEl) emptyEl.hidden = shown !== 0;
      if (root._olFitVisible) root._olFitVisible();
    }

    // ---- Events ----
    cards.forEach(function (card, i) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('a')) return; // no robar clics de botones
        highlight(stores[i], true);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); highlight(stores[i], true); }
      });
    });

    if (searchEl) {
      searchEl.addEventListener('input', function () {
        query = deaccent(searchEl.value.trim());
        applyFilters();
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        activeRegion = chip.getAttribute('data-ol-chip') || '';
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        applyFilters();
      });
    });

    viewBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var view = btn.getAttribute('data-ol-view');
        viewBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (bodyEl) bodyEl.setAttribute('data-ol-view-state', view);
        if (view === 'map' && root._olMap) setTimeout(function () { root._olMap.invalidateSize(); root._olFitVisible(); }, 60);
      });
    });
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-odara-locator]')).forEach(initLocator);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
